import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { CONSTANTS } from "app/constants";
import { PlayerService } from "app/services";
import { BehaviorSubject, Subscription } from "rxjs";
import { PlayerDto, PlayerSettingsDto, TacticDto, TacticPlayerDto, TeamCardsDto } from "../../models";
import { PlayerModal, PlayerSettingsModal, PlayerSkillsModal } from "../modals";

@Component({
    selector: 'tactic-player',
    templateUrl: './tactic-player.component.html',
    styleUrls: ['./tactic-player.component.scss'],
})
export class TacticPlayer implements OnInit, OnDestroy  {
    @Input()
    formUrl: string;

    @Input()
    playersDictionary: PlayerDto[];

    @Input()
    squadPlayers: PlayerDto[];

    @Input()
    substPlayers: PlayerDto[];

    @Input()
    reservePlayers: PlayerDto[];

    @Input()
    set tactic(value: TacticDto) {
        this.currentTactic = value;
        this.init();
    }

    get tactic() : TacticDto {
        return this.currentTactic;
    }

    @Input()
    set position(val: number) {
        this.playerPosition = val;
    }

    get position(): number {
        return this.playerPosition;
    }

    @Input()
    set side(val: number) {
        this.playerSide = val;
    }

    get side(): number {
        return this.playerSide;
    }

    @Input()
    set selectedPlayer(val: number) {
        this.selectedPlayerId = val;

        this.isPlayerSelected = this.player && this.selectedPlayerId === this.player.id;
    }

    get selectedPlayer(): number {
        return this.selectedPlayerId;
    }

    @Input()
    set opponent(val: PlayerDto[]) {
        this.opponentSuqad = val;
    }

    get opponent(): PlayerDto[] {
        return this.opponentSuqad;
    }

    @Input()
    set teamCards(val: TeamCardsDto) {
        this.cards = val;
        this.processTeamCards();
    }

    get teamCards(): TeamCardsDto {
        return this.cards;
    }

    @Input()
    refreshEvent: BehaviorSubject<boolean>;

    @Output() selectPlayer: EventEmitter<number> =  new EventEmitter();
    @Output() movePlayer: EventEmitter<number> =  new EventEmitter();
    @Output() changePlayer: EventEmitter<number> =  new EventEmitter();

    const;

    isPlayerSelected: boolean = false;

    isMoveControlVisible: boolean = false;
    isLeftMoveControlVisible: boolean = false;
    isRightMoveControlVisible: boolean = false;
    isUpMoveControlVisible: boolean = false;
    isDownMoveControlVisible: boolean = false;

    isGk: boolean = false;

    isBanned: boolean = false;
    isYellowCard: boolean = false;
    isPositionInvalid: boolean = false;

    private selectedPlayerId: number;

    private currentTactic: TacticDto;

    player: PlayerDto = null;

    private playerPosition: number;
    private playerSide: number;
    private opponentSuqad: PlayerDto[];

    private refreshSubscription: Subscription;

    private cards: TeamCardsDto;


    constructor(private modalService: NgbModal, private playerService: PlayerService) {
        this.const = CONSTANTS;
    }

    ngOnInit(): void {
        this.init();
        this.refreshSubscription = this.refreshEvent.subscribe((val) => {
            this.init();
        });
    }

    ngOnDestroy(): void {
        this.refreshSubscription.unsubscribe();
    }

    getPlayerLastName(): any {
        if (!this.player) {
            return null;
        }

        return this.player.surname;
    }

    

    getPlayerFirstName(): any {
        if (!this.player || !this.player.name) {
            return null;
        }

        return this.player.name[0] + ".";
    }

    onSelectPlayer(ev) {
        ev.stopPropagation();
        this.selectPlayer.emit(this.player.id);
    }

    moveLeft(ev) {
        ev.stopPropagation();
        this.movePlayer.emit(CONSTANTS.playerMoveDirections.left);
    }

    moveUp(ev) {
        ev.stopPropagation();
        this.movePlayer.emit(CONSTANTS.playerMoveDirections.up);
    }
    moveDown(ev) {
        ev.stopPropagation();
        this.movePlayer.emit(CONSTANTS.playerMoveDirections.down);
    }
    moveRight(ev) {
        ev.stopPropagation();
        this.movePlayer.emit(CONSTANTS.playerMoveDirections.right);
    }

    onChangePlayer(ev) {
        ev.stopPropagation();

        const modalRef = this.modalService.open(PlayerModal);

        //modalRef.componentInstance.squadPlayers= this.squadPlayers;
        modalRef.componentInstance.squadPlayers = this.playerService.sortTacticPlayersByPosition(this.tactic.squad, this.squadPlayers);
        modalRef.componentInstance.substitutionPlayers = this.playerService.sortPlayersByPosition(this.substPlayers);
        modalRef.componentInstance.resevePlayers = this.playerService.sortPlayersByPosition(this.reservePlayers);
        modalRef.componentInstance.selectedPlayer = this.player;

        modalRef.result.then((result) => {
            if (result) {
                this.changePlayer.emit(result);
            }
        }, (reason) => {});
    }

    onChangePlayerSettings(ev) {
        ev.stopPropagation();

        const modalRef = this.modalService.open(PlayerSettingsModal);

        let playerSettings = this.currentTactic.playersSettings.find(item => item.playerId == this.selectedPlayerId);

        modalRef.componentInstance.playerSettings = playerSettings ? playerSettings : this.getDefaultPlayerSettings();
        modalRef.componentInstance.playerName = this.getPlayerFirstName() + this.getPlayerLastName();
        modalRef.componentInstance.isGk = this.isGk;
        modalRef.componentInstance.opponent = this.opponent;

        modalRef.result.then((result) => {
            if (result) {
                
            }
        }, (reason) => { });
    }

    onShowPlayerSkills(ev) {
        ev.stopPropagation();
        
        const modalRef = this.modalService.open(PlayerSkillsModal);

        modalRef.componentInstance.player = this.player;

        modalRef.result.then((result) => {
            if (result) {
                
            }
        }, (reason) => { });

    }

    getPlayerPositionLabel() {
        return this.playerService.formatPlayerPosition(this.player);
    }


    private getTacticPlayerByPosition(pos: number, side: number): TacticPlayerDto {
        var result = this.currentTactic.squad.find(element => {
            return (element.position === pos && element.side === side)
        });

        return result;
    }

    private init() {
        this.isMoveControlVisible = this.position !== CONSTANTS.tacticPositions.gk;
        this.isLeftMoveControlVisible =  (this.position !== CONSTANTS.tacticPositions.sw) && this.side !== CONSTANTS.tacticSides.l;
        this.isRightMoveControlVisible = (this.position !== CONSTANTS.tacticPositions.sw) && this.side !== CONSTANTS.tacticSides.r;
        this.isUpMoveControlVisible = (this.position !== CONSTANTS.tacticPositions.fw) && !(this.position === CONSTANTS.tacticPositions.sw && this.side !== CONSTANTS.tacticSides.c);
        this.isDownMoveControlVisible = (this.position !== CONSTANTS.tacticPositions.sw) && !(this.position === CONSTANTS.tacticPositions.df && this.side !== CONSTANTS.tacticSides.c);

        let tacticPlayer = this.getTacticPlayerByPosition(this.position, this.side);

        this.isGk = this.position === CONSTANTS.tacticPositions.gk;

        if (tacticPlayer && tacticPlayer.playerId) {
            this.player = this.playersDictionary[tacticPlayer.playerId];

            this.isPlayerSelected = this.selectedPlayerId === this.player.id;

            this.detectInvalidPosition();

            this.processTeamCards();
        }

        
    }

    private getDefaultPlayerSettings() : PlayerSettingsDto {
        let result = new PlayerSettingsDto();

        result.attackHelp = CONSTANTS.playerSettings.variant3.sometimes;
        result.cutPass = CONSTANTS.playerSettings.variant3.sometimes;
        result.defenceHelp = CONSTANTS.playerSettings.variant3.sometimes;
        result.dribbling = CONSTANTS.playerSettings.variant3.sometimes;
        result.freeRole = CONSTANTS.playerSettings.variant2.no;
        result.longShots = CONSTANTS.playerSettings.variant3.sometimes;
        result.offside = CONSTANTS.playerSettings.variant3.sometimes;
        result.passType = CONSTANTS.playerSettings.passTypes.team;
        result.standardAtttack = CONSTANTS.playerSettings.variant2.no;
        result.standardDefence = CONSTANTS.playerSettings.variant2.no;
        result.tacticNumber = this.currentTactic.number;
        result.playerId = this.selectedPlayerId;



        return result;
    }

    private processTeamCards() {
        if (!this.player || !this.cards)
            return;

        this.isYellowCard = this.cards.yellowCards.includes(this.player.id);
        this.isBanned = this.cards.redCards.find(c=>c.playerId === this.player.id) !== undefined;
    }

    private detectInvalidPosition() {
        this.isPositionInvalid = false;

        switch (this.position) {
            case CONSTANTS.tacticPositions.gk:
                if (!this.player.isGK) this.isPositionInvalid = true;
            break;
            case CONSTANTS.tacticPositions.sw:
                if (!this.player.isSW) this.isPositionInvalid = true;
            break;
            case CONSTANTS.tacticPositions.df:
                if (!this.player.isDF) this.isPositionInvalid = true;
            break;
            case CONSTANTS.tacticPositions.dm:
                if (!this.player.isDM) this.isPositionInvalid = true;
            break;
            case CONSTANTS.tacticPositions.mf:
                if (!this.player.isMF) this.isPositionInvalid = true;
            break;
            case CONSTANTS.tacticPositions.am:
                if (!this.player.isAM) this.isPositionInvalid = true;
            break;
            case CONSTANTS.tacticPositions.fw:
                if (!this.player.isFW) this.isPositionInvalid = true;
            break;

        }

        if (!this.player.isGK) {
            switch (this.side) {
                case CONSTANTS.tacticSides.c:
                case CONSTANTS.tacticSides.lc:
                case CONSTANTS.tacticSides.rc:
                    if (!this.player.isCenter) this.isPositionInvalid = true;
                break;
                case CONSTANTS.tacticSides.l:
                    if (!this.player.isLeft) this.isPositionInvalid = true;
                break;
                case CONSTANTS.tacticSides.r:
                    if (!this.player.isRight) this.isPositionInvalid = true;
                break;
            }
        }
    }

}